// for Normal video
// let playVideo = document.querySelector('video.player');
// if(playVideo) {
//   $('.video-wrapper .play-icon').on('click touchstart', function() {
//       console.log('Play icon clicked');
//       let wrapper = $(this).closest('.video-wrapper');
//       let video = wrapper.find('.player').get(0);
  
//       setTimeout(function() {
//           video.muted = true; // Mute the video
//           video.loop = true; // Loop the video
//           video.play(); // Play the video
  
//           // Hide the play icon and overlay
//           wrapper.find('.play-icon').hide();
//           wrapper.find('.image-over-layer').hide();
//       }, 500);
//       $(video).on('pause', function () {
//           wrapper.find('.play-icon').show();
//           wrapper.find('.image-over-layer').show();
//       });

//   });
// }
// // Youtube video
// let playiframe = document.querySelector('iframe#player');
//   if (playiframe) {
//    document.addEventListener('DOMContentLoaded', function() {
//       document.querySelector('.video-wrapper .play-icon').addEventListener('click', function() {
//           let iframe = document.getElementById('player');
//           let iframeSrc = iframe.getAttribute('src');
  
//           if (iframeSrc.includes('?')) {
//               iframe.setAttribute('src', iframeSrc + '&autoplay=1&loop=1&autopause=0&muted=1');
//           } else {
//               iframe.setAttribute('src', iframeSrc + '?autoplay=1&loop=1&autopause=0&muted=1');
//           }
  
//           this.style.display = 'none';
//           document.querySelector('.video-wrapper .image-over-layer').style.display = 'none';
//       });
//   });
// }

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.video-wrapper .play-button, .video-wrapper .play-icon').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrapper = this.closest('.video-wrapper');
      var video   = wrapper.querySelector('video.player');
      var ytId    = wrapper.getAttribute('data-youtube-id');
      var ytSlot  = wrapper.querySelector('.youtube-embed-slot');

      if (ytId && ytSlot) {
        // ---- YouTube video ----
        if (!ytSlot.querySelector('iframe')) {
          var iframe = document.createElement('iframe');
          iframe.className = 'player youtube-player';
          iframe.src = 'https://www.youtube.com/embed/' + ytId
                     + '?autoplay=1&mute=1&loop=1&playlist=' + ytId
                     + '&controls=1&rel=0&modestbranding=1&playsinline=1';
          iframe.setAttribute('frameborder', '0');
          iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
          iframe.setAttribute('allowfullscreen', '');
          ytSlot.appendChild(iframe);
        }
      } else if (video) {
        // ---- Uploaded video ----
        video.muted = true;
        video.loop  = true;
        video.play().catch(function (err) {
          console.error('Video play failed:', err);
        });
      }

      var overlay = wrapper.querySelector('.image-over-layer');
      if (overlay) overlay.style.display = 'none';
      this.style.display = 'none';
    });
  });
});

if ($('body').hasClass('product-custom-rolex')) {
  $('.model-info_spec_heading').each(function(){
      var addClassHeding = $(this).text().toLowerCase().replace(/\s/g, '');
      $(this).addClass(addClassHeding);
  });
  
  // $( $('.model-info_spec_heading.waterresistance').parent() ).insertAfter( $('.model-info_spec_heading.modelcase').parent() );
  // $( $('.model-info_spec_heading.dial').parent() ).insertAfter( $('.model-info_spec_heading.bezel').parent() );
  // $( $('.model-info_spec_heading.bracelet').parent() ).insertBefore( $('.model-info_spec_heading.caliber').parent() );
  // $( $('.model-info_spec_heading.movement').parent() ).insertAfter( $('.model-info_spec_heading.bracelet').parent() );
}


// article page published-date shifting
const publishDate = document.querySelector('#publish-date');
if (publishDate) {
  let shiftedPublishedDate = publishDate.cloneNode(true);
  let targetElement = publishDate.parentElement.nextElementSibling.nextElementSibling.querySelector('.content-section')
  if(targetElement){
    targetElement.appendChild(shiftedPublishedDate);
  }
  publishDate.style.display = "none";
}

// accordion js start

$(document).ready(function () {
    // Collapse all items by default
    $(".accordion-content").hide();
    $(".accordion-header").removeClass("active");

    // Clear conflicting states and expand the first item by default
    // localStorage.clear();
    $(".accordion-item:first .accordion-content").show();
    $(".accordion-item:first .accordion-header").addClass("active");

    // Attach click event handler
    $(".accordion-header").click(function () {
        // Collapse any expanded items
        $(".accordion-content").slideUp();
        $(".accordion-arrow").removeClass("rotate");
        $(".accordion-header").removeClass("active");

        // Check if the clicked item is already expanded, then just collapse it
        if ($(this).next(".accordion-content").is(":visible")) {
            $(this).removeClass('active');
            $(this).next(".accordion-content").slideUp(500);
            $(this).find(".accordion-arrow").removeClass("rotate");
        } else {
            // Expand the clicked item's content
            $(this).addClass('active');
            $(this).next(".accordion-content").slideDown(500);
            $(this).find(".accordion-arrow").addClass("rotate");
        }
    });
});

// accordion js end


// rolex-custom-nav Start
document.querySelectorAll('.rolexNav-toggle').forEach(function(item) {
    item.addEventListener('click', function(e) {
        const target = '.' + e.currentTarget.getAttribute('data-target');
        if (e.currentTarget.classList.contains('is-open')) {
            e.currentTarget.classList.remove('is-open');
            document.querySelector(target).classList.remove('is-open');
        } else {
            document.querySelector(target).classList.add('is-open');
            e.currentTarget.classList.add('is-open');
        }
    });
});

if (document.querySelectorAll('a.rolex-upArrow').length > 0) {
    document.querySelectorAll('a.rolex-upArrow').forEach(function(item) {
        item.addEventListener('click', function(e) {
            e.preventDefault();
            const target = e.currentTarget.getAttribute('href');
            const offsetTop = document.querySelector(target).offsetTop;
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });
        });
    });
}
// rolex-custom-nav End

// rolex custom carousel Start
if (document.querySelector('#explorecarousel-slider')) {
if (document.querySelectorAll('#explorecarousel-slider .exploreCarousel-item-custom').length > 4) {
    var flkty = new Flickity('#explorecarousel-slider .exploreCarousel-list', {
        cellAlign: 'left',
        contain: true,
        wrapAround: false,
        lazyLoad: 2,
        prevNextButtons: true,
        pageDots: true,
        groupCells: true,
        autoPlay: false, 
        dragThreshold: 10,
        selectedAttraction: 0.2, 
        friction: 0.8, 
        slidesToShow: 2, 
        slidesToScroll: 2, 
       responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            }
        ]
    });
}
}
// custom carousel End


// rolex custom collection carousel Start
if (document.querySelector('#collections-slider')) {
if (document.querySelectorAll('#collections-slider .exploreCarousel-item-collection-carousel').length > 4) {
    var flkty = new Flickity('#collections-slider .exploreCarousel-list', {
        cellAlign: 'left',
        contain: true,
        wrapAround: false,
        lazyLoad: 2,
        prevNextButtons: true,
        pageDots: true,
        groupCells: true,
        autoPlay: false, 
        dragThreshold: 10,
        selectedAttraction: 0.2, 
        friction: 0.8, 
        slidesToShow: 2, 
        slidesToScroll: 2, 
       responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            }
        ]
    });
}
}
// custom carousel End


// Banner slider
if (document.querySelector('#banner-slider')) {
    if (document.querySelectorAll('#banner-slider .exploreCarousel-item-banner').length > 1) {
        var flkty = new Flickity('#banner-slider .exploreCarousel-list', {
            cellAlign: 'left',
            contain: false,
            wrapAround: false,
            lazyLoad: 2,
            prevNextButtons: true,
            pageDots: true,
            groupCells: true,
            autoPlay: false, 
            dragThreshold: 10,
            selectedAttraction: 0.2, 
            friction: 0.8, 
            slidesToShow: 1, 
            slidesToScroll: 1, 
        });
    }
}
// custom carousel End


// rolex custom carousel Start
if (document.querySelector('#new-watches-carousel')) {
if (document.querySelectorAll('#new-watches-carousel .exploreCarousel-item-new-watches').length > 4) {
    var flkty = new Flickity('#new-watches-carousel .exploreCarousel-list', {
        cellAlign: 'left',
        contain: true,
        wrapAround: false,
        lazyLoad: 2,
        prevNextButtons: true,
        pageDots: true,
        groupCells: true,
        autoPlay: false, 
        dragThreshold: 10,
        selectedAttraction: 0.2, 
        friction: 0.8, 
        slidesToShow: 2, 
        slidesToScroll: 2, 
       responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            }
        ]
    });
}
}
// custom carousel End


// model-availability button JS Start

    const modelLinks = document.querySelectorAll('.model-primary_avail');

    modelLinks.forEach(link => {
        link.addEventListener('click',  scroolEffect );
    });

const rolexBackarrow = document.querySelectorAll('.rolex-backArrow');

    rolexBackarrow.forEach(link => {
        link.addEventListener('click',  scroolEffect );
    });

  function scroolEffect(event){
      event.preventDefault();
            
            const targetId = this.getAttribute('href').substring(1);

            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
            }
  }

// model-availability button JS End


// World rolex or blog page code

jQuery(document).ready(function () {
        jQuery('.rolexblog a').on('click', function() {
      jQuery('body').addClass('rolexpostonly');
      jQuery('.otherblog').hide();
      jQuery('.eventblog').hide();
      jQuery('.exploreCarousel-list').slick('refresh');
     
    });
    jQuery(function(){
       var hash = jQuery(location).attr('hash');
       jQuery('body').addClass(hash);
    });
    if(window.location.href === "https://polachecks-sandbox-2.myshopify.com/pages/world-of-rolex/#rolex"){
       jQuery('body').addClass('rolexpostonly');
    }
    })



    jQuery(document).ready(function () {
        jQuery('.otherblog a').on('click', function() {
      jQuery('body').addClass('otherblogpostonly');
      jQuery('.rolexblog').hide();
      jQuery('.eventblog').hide();
      jQuery(window).scrollTop(0);
     
    });
    if(window.location.href === "https://polachecks-sandbox-2.myshopify.com/pages/world-of-rolex/#polachecksnews"){
       jQuery('body').addClass('otherblogpostonly');
    }   
    })




    jQuery(document).ready(function () {
        jQuery('.eventblog a').on('click', function() {
      jQuery('body').addClass('eventblogpostonly');
      jQuery('.rolexblog').hide();
      jQuery('.otherblog').hide();
      jQuery(window).scrollTop(0);
     
    });
    if(window.location.href === "https://polachecks-sandbox-2.myshopify.com/pages/world-of-rolex/#event"){
       jQuery('body').addClass('eventblogpostonly');
    }   
    })


jQuery('.tag a:contains("#rolex")').closest('.blog').addClass('rolexpost');
jQuery('.tag a:contains("#event")').closest('.blog').addClass('eventpost');
jQuery(".rolexpost").each(function(index){
    jQuery(this).addClass('tab'+(index+1));
  })




// Store Opening time

 // The day of the week (0 to 6). Sunday = 0 etc.
        const date = new Date();
        const today = date.getDay().toString();
        const daysList = $('div.hoursItem');
        // updates the current hours of the store on the dropdown of the individual contact pages
        for (let index = 0; index < daysList.length; index++) {
            const day = daysList[index];
            if (today === $(day).attr('data-day').toString()) {
                if ($(day).find('strong span.hours').text().toLowerCase() === 'closed') {
                    $('label.currentHours').addClass('closed');
                }
                const data = $(day).find('.hours').text();
                $('label.currentHours strong .hours').text(data);
            }
        }
        // dropdown toggle
        $('button.hoursList-toggle').on('click', (e) => {
            if ($('div.hoursList').hasClass('is-active')) {
                $('div.hoursList').removeClass('is-active');
                $(e.currentTarget).removeClass('is-active');
            } else {
                $(e.currentTarget).addClass('is-active');
                $('div.hoursList').addClass('is-active');
            }
        });


/* Products Load More button */

$(document).ready(function() {
  
  var numberOfProductsToShow = 6;
  if (window.location.pathname.includes("/collections/rolex-accessories")) {
        numberOfProductsToShow = 10;
    }
    if(window.location.pathname.includes("/collections/festive-selection")){
        numberOfProductsToShow = 15;
    }

  function showProducts(startIndex, endIndex) {
    $('.custom-collection-list .product').each(function(index, product) {
      if (index >= startIndex && index < endIndex) {
        $(product).css('display', 'block');
      } else {
        $(product).css('display', 'none');
      }
    });

    var loadMore = $('.product-load-more-btn');
    if (endIndex >= $('.custom-collection-list .product').length) {
      loadMore.hide();
    } else {
      loadMore.show();
    }
  }

  showProducts(0, numberOfProductsToShow);

  $('.product-load-more-btn').on('click', function() {
    var loadMore = $(this);
    loadMore.html("Loading...");
    setTimeout(function() {
      numberOfProductsToShow += 6;
      showProducts(0, numberOfProductsToShow);
      loadMore.html("Load more");
    }, 1000);
  });
});

// model page carousel
  function updateGalleryNavAndBox() {
      // const galleryNav = document.querySelector('.rolex-product-details .product__images .product_gallery_nav');
      const galleryNavDesktop = document.querySelector('.rolex-product-details .rolex-thumbnail-container.slider-desktop');
      const box = document.querySelector('.rolex-product-details.product_section');
  
      if (galleryNavDesktop && box) {
          const galleryNavHeight = galleryNavDesktop.offsetHeight;
  
          // Update box margin dynamically based on galleryNavDesktop height
          if (window.innerWidth < 768) {
            box.style.marginBottom = "";
          } else {
            box.style.marginBottom = `${galleryNavHeight + 10}px`;
          }
      }
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(updateGalleryNavAndBox, 1000);
  });
  
  // Add an event listener for window resize to handle responsiveness
  window.addEventListener('resize',()=>{
    setTimeout(updateGalleryNavAndBox, 200);  
  });

$(document).ready(function() {
    var $carousel = $('.exploreCarousel-list').flickity();
    $carousel.flickity('resize');
});


/* Contact page MAP and List tab code */

  // function goToByScroll(id) {
  //   document.documentElement.scrollTop = document.getElementById(id).offsetTop;
  //   document.body.scrollTop = document.getElementById(id).offsetTop;
  // }

  document.addEventListener("DOMContentLoaded", function() {
    var storesListLink = document.getElementById('stores_list_link');
    var storesMapLink = document.getElementById('stores_map_link');
    var mapView = document.getElementById('map_view');
    var listView = document.getElementById('list_view');
    var mapCanvas = document.getElementById('map_canvas');

    storesListLink.addEventListener("click", function(e) {
      e.preventDefault();
      mapView.style.display = 'none';
      listView.style.display = 'flex';
      storesListLink.classList.add('active');
      storesMapLink.classList.remove('active');
    });

    storesMapLink.addEventListener("click", function(e) {
      e.preventDefault();
      mapView.style.display = 'block';
      listView.style.display = 'none';
      storesListLink.classList.remove('active');
      storesMapLink.classList.add('active');
    });

    zipcode = 89109;
    var t = window.outerWidth
  });


// Contact us and Store pages MAP Code

    function goToByScroll(id) {
        $('html,body').animate({
            scrollTop: $("#" + id).offset().top
        }, 'slow');
    }
                
    $(document).ready(function() {
        // zipcode = 89109;
        var t = $(window).outerWidth();

        $('#map_canvas').css('height', '550px');

        initialize_map();

    });
                
function initialize_map() {

        var allLocations = [['Polachecks Jewelers', '34.1533802', '-118.647112', '0', '4719 Commons Way <br/>Calabasas California 91302', '312-663-8500', '/pages/rolex-contact-calabasas', 'https://g.page/polachecks-jewelers-calabasas?share', '/public/AMPFUSION/brands/skeleton/images/stock2_300x220.jpg'],['Polachecks Jewelers', '34.190191', '-118.6056364', '0', '6600 Topanga Canyon Blvd <br/>Space 1084C Canoga Park, CA 91303', '312-663-8500', '/pages/rolex-contact-canogapark', 'https://www.google.com/search?q=polachecks-jewelers-canopark', '/public/AMPFUSION/brands/skeleton/images/stock2_300x220.jpg'] ];
        // var map = new google.maps.Map(document.getElementById('map_canvas'),{
        //     zoom: 12,
        //     center: new google.maps.LatLng(34.1533802,-118.647112),
        //     mapTypeControlOptions: {
        //         mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'tehgrayz']
        //     }
        // });
        var currentPath = window.location.pathname.replace(/\/+$/, '').toLowerCase();
    var locations = allLocations.filter(function (loc) {
        return loc[6].replace(/\/+$/, '').toLowerCase() === currentPath;
    });

    var isSingleStore = locations.length === 1;
    if (!isSingleStore) locations = allLocations;   // fallback: main contact page shows all

    var defaultCenter = isSingleStore
        ? new google.maps.LatLng(locations[0][1], locations[0][2])
        : new google.maps.LatLng(34.1533802, -118.647112);
    var defaultZoom = isSingleStore ? 15 : 12;

    var map = new google.maps.Map(document.getElementById('map_canvas'), {
        zoom: defaultZoom,
        center: defaultCenter,
        mapTypeControlOptions: {
            mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'tehgrayz']
        }
    });
       var stylez = [{
                "featureType": "administrative",
                "elementType": "all",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "administrative",
                "elementType": "labels",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#6e6c6c"
                }]
            }, {
                "featureType": "administrative.country",
                "elementType": "geometry",
                "stylers": [{
                    "weight": "0.85"
                }, {
                    "lightness": "45"
                }, {
                    "visibility": "on"
                }]
            }, {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [{
                    "color": "#f2f2f2"
                }]
            }, {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [{
                    "gamma": "1.09"
                }, {
                    "lightness": "19"
                }]
            }, {
                "featureType": "landscape",
                "elementType": "labels",
                "stylers": [{
                    "visibility": "on"
                }, {
                    "lightness": "-21"
                }, {
                    "weight": "0.01"
                }]
            }, {
                "featureType": "landscape.natural.landcover",
                "elementType": "geometry",
                "stylers": [{
                    "saturation": "8"
                }, {
                    "lightness": "8"
                }]
            }, {
                "featureType": "landscape.natural.landcover",
                "elementType": "geometry.fill",
                "stylers": [{
                    "lightness": "6"
                }]
            }, {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [{
                    "visibility": "off"
                }, {
                    "saturation": "1"
                }, {
                    "color": "#cfe1d3"
                }]
            }, {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "poi.attraction",
                "elementType": "labels",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "poi.medical",
                "elementType": "geometry.fill",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "poi.medical",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [{
                    "visibility": "on"
                }, {
                    "color": "#cfe1d3"
                }]
            }, {
                "featureType": "road",
                "elementType": "all",
                "stylers": [{
                    "saturation": -100
                }, {
                    "lightness": 45
                }]
            }, {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [{
                    "visibility": "on"
                }, {
                    "color": "#dcdfe2"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "labels.icon",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "road.highway.controlled_access",
                "elementType": "geometry",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "road.highway.controlled_access",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "road.highway.controlled_access",
                "elementType": "labels",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "road.local",
                "elementType": "all",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "road.local",
                "elementType": "geometry.fill",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "road.local",
                "elementType": "labels",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "transit",
                "elementType": "geometry.fill",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "transit.station",
                "elementType": "all",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [{
                    "gamma": "1.57"
                }, {
                    "lightness": "-10"
                }]
            }, {
                "featureType": "transit.station",
                "elementType": "labels",
                "stylers": [{
                    "weight": "0.01"
                }, {
                    "visibility": "on"
                }, {
                    "saturation": "-100"
                }, {
                    "lightness": "-3"
                }]
            }, {
                "featureType": "transit.station",
                "elementType": "labels.icon",
                "stylers": [{
                    "weight": "0.01"
                }]
            }, {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#c2d8e1"
                }]
            }, {
                "featureType": "water",
                "elementType": "labels.text",
                "stylers": [{
                    "visibility": "on"
                }, {
                    "color": "#b0bdc7"
                }]
            }];
					
        var mapType = new google.maps.StyledMapType(stylez,{
            name: "Locations"
        });
        map.mapTypes.set('tehgrayz', mapType);
        map.setMapTypeId('tehgrayz');

        var marker, i;

        for (i = 0; i < locations.length; i++) {
            marker = new google.maps.Marker({
                position: new google.maps.LatLng(locations[i][1],locations[i][2]),
                map: map,
                icon: 'https://s3.amazonaws.com/ISHOWIMAGES/Rolex/Rolex+Module/Contact+Us+Pages/retailer.png'
            });

            google.maps.event.addListener(marker, 'click', (function(marker, i) {
                return function() {

                    marker.setIcon('https://s3.amazonaws.com/ISHOWIMAGES/Rolex/Rolex+Module/Contact+Us+Pages/retailer_selected.png');

                    $('#selected_store_details').css('visibility', 'visible');
                    $('#selected_store_details').css('opacity', 1);
                    $('#selected_store_details').css('display', 'block');
                    map.setZoom(18);
                    map.panTo(this.getPosition());

                    $('#rolex_store_name').html(locations[i][0]);
                    $('#rolex_store_address').html(locations[i][4]);
                    $('#rolex_store_phone').html(locations[i][5]);
                    $("#rlxContactCall").attr("href", "tel:" + locations[i][5]);
                    $("#rolex_store_link").attr("href", locations[i][6]);
                    $("#rolex_store_directions").attr("href", locations[i][7]);
                    $("#store_image").css("background-image", "url(" + locations[i][8] + ")");

                    $('#store_close_button').on('click', (function(e) {
                        e.preventDefault();
                        map.setZoom(12);
                        map.setCenter(new google.maps.LatLng(34.1533802,-118.647112));
                        $('#selected_store_details').css('visibility', 'hidden');
                        $('#selected_store_details').css('opacity', 0);

                        marker.setIcon('https://s3.amazonaws.com/ISHOWIMAGES/Rolex/Rolex+Module/Contact+Us+Pages/retailer.png');

                    }
                    ));
                }
            }
            )(marker, i));

        }
}
